export const defaultSettings = {
  powerforms_enable_api_based_dss_fetch: false,
};
